import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import h from '../../helpers/common';
import { useMpxFeed } from '../../hooks/data/useMpxFeed';
import { useConfigurationSections } from '../../hooks/useConfiguration';
import { __ } from '../../translations';
import { transformVOD } from '../../utils/vodTransformer';
import GenericVerticalList from './GenericVerticalList';
import { GenericVodCarousel } from './GenericVodCarousel';

type MpxFeedCarouselProps = {
    carousel: Carousel;
    data?: any;
};

export const MpxFeedCarousel: React.FC<MpxFeedCarouselProps> = ({ carousel }) => {
    // Using React Query instead of Redux for configuration
    const { config } = useConfigurationSections();
    const { data, isLoading, isError, error } = useMpxFeed(carousel);

    // Early return if there's an error
    if (isError) {
        return;
    }

    // Only render if we have data or are loading
    if (isLoading || data?.entries?.length) {
        if (carousel?.layoutType?.toUpperCase() === 'VERTICAL') {
            return (
                <GenericVerticalList
                    isLoading={isLoading}
                    content={data?.entries?.map((e) => transformVOD(e, config.promotionProviderImages))}
                    params={{ items_count: data?.entries?.length, filter_params: carousel.dataSources }}
                    meta={{
                        title: {
                            en: __(carousel.title_resource_key, { lng: 'en' }),
                            ar: __(carousel.title_resource_key),
                        },
                    }}
                    carousel={carousel}
                />
            );
        }

        return (
            <GenericVodCarousel
                isLoading={isLoading}
                language={h.getLang()}
                content={data?.entries?.map((e) => transformVOD(e, config.promotionProviderImages))}
                id={carousel.id}
                title={carousel.title_resource_key}
                name={carousel.id}
                params={{ items_count: data?.entries?.length, filter_params: carousel.dataSources }}
                data_stream={carousel.id}
                meta={{ title: { en: carousel.title_resource_key, ar: carousel.title_resource_key } }}
                carousel={carousel}
                data={data?.data}
            />
        );
    }

    // If no data and not loading, return null
    return null;
};
